export default () => ({
	image: null,
	active: false,
	parseImage() {
		const tgt = this.$refs.input;
        const files = tgt.files;

		// FileReader support
		if (FileReader && files && files.length && this.isImage(files[0].name)) {
			const fr = new FileReader();
			fr.onload = () => {
				this.image = fr.result;
			}
			fr.readAsDataURL(files[0]);
		}
		// Not supported
		else {
			// fallback -- perhaps submit the input to an iframe and temporarily store
			// them on the server until the user's session ends.
			this.image = null;
		}
	},
	isImage(filename) {
		const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
		return allowedExtensions.exec(filename);
	}
});
